module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.error[0]
    }
  }, [_c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Сумма")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "currency": _vm.currencySign(),
      "currency-symbol-position": "suffix",
      "type": "text",
      "separator": ",",
      "minus": false,
      "precision": 2,
      "id": "amount",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localValue),
      callback: function($$v) {
        _vm.localValue = $$v
      },
      expression: "localValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error[0]))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce8a6ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/transaction/fields/Amount.vue
// module id = 593
// module chunks = 0